const Success = {
    install(app, options = {}) {
        app.config.globalProperties.$success = (message) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'bottom',
                duration: 5000,
                variant: 'success',
                rootClass: 'toast-notification'
            });
        };
        app.provide("$success", app.config.globalProperties.$success);
    }
};
const Error = {
    install(app, options = {}) {
        app.config.globalProperties.$error = (message, duration) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'bottom',
                duration: duration || 5000,
                variant: 'danger',
                rootClass: 'toast-notification'
            });
        };
        app.provide("$error", app.config.globalProperties.$error);
    }
};
const Warn = {
    install(app, options = {}) {
        app.config.globalProperties.$warn = (message) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'bottom',
                duration: 5000,
                variant: 'warning',
                rootClass: 'toast-notification'
            });
        };
        app.provide("$warn", app.config.globalProperties.$warn);
    }
};
export default {
    Success,
    Error,
    Warn
};
